'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cancel = exports.isCancel = exports.CancelToken = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// fixed axios  not effective on above 1.0.0ver
var HEADER_CONTENT_TYPE = 'Content-Type';
var STR_GET = 'get';
var APPLICATION_JSON = 'application/json;charset=utf-8';
var APPLICATION_FORM = 'application/x-www-form-urlencoded;charset=utf-8';

var validateStatus = function validateStatus(status) {
  return status >= 200 && status < 300;
};

var STR_JSON = 'json';
var DEFAULTS = {
  validateCode: validateStatus,
  validateStatus: validateStatus,
  responseType: STR_JSON,
  baseURL: function () {
    try {
      return process.env.AXIOS_BASE_URL || '';
    } catch (e) {
      return '';
    }
  }()
};

function agent(config) {
  if (typeof config === 'string') {
    return agent({
      url: config
    });
  } else {
    config = (0, _assign2.default)({}, config);
  }

  if (typeof config.url !== 'string') {
    throw new Error('url must be a string');
  }

  var headers = {};
  // const auth = cookie.get('JSESSIONID')
  // const uuid = cookie.get('UUID')
  var validateStatus = config.validateStatus || DEFAULTS.validateStatus;

  var validateCode = config.validateCode || DEFAULTS.validateCode;
  delete config.validateCode;

  config.headers = (0, _assign2.default)(headers, config.headers);
  config.validateStatus = function () {
    return true;
  };
  config.method = typeof config.method === 'string' ? config.method.toLowerCase() : STR_GET;

  // Set default withCredentials to true
  config.withCredentials = 'withCredentials' in config ? config.withCredentials : true;

  config.baseURL = 'baseURL' in config ? config.baseURL : DEFAULTS.baseURL;

  config.responseType = config.responseType || 'json';

  var data = void 0;

  if (config.method === STR_GET) {
    delete config.data;
    delete headers[HEADER_CONTENT_TYPE];

    // Skip axios.transformRequest
  } else if (data = config.json) {
    delete config.json;
    config.data = (0, _stringify2.default)(data);
    headers[HEADER_CONTENT_TYPE] = APPLICATION_JSON;
  } else if (data = config.form) {
    delete config.form;
    config.data = _queryString2.default.stringify(data);
    headers[HEADER_CONTENT_TYPE] = APPLICATION_FORM;
  }

  return (0, _axios2.default)(config).then(function (response) {
    var status = response.status;

    if (!validateStatus(status)) {
      return errorResponse(response, config);
    }

    var res = makeResponse(response, config);

    if (config.responseType !== 'json' || validateCode(res.code)) {
      return res;
    }

    return _promise2.default.reject(res);
  });
}

// @param {Object} dc default config
agent.defaults = function (dc) {
  // @param {Object} uc user config
  return function () {
    var uc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var config = (0, _assign2.default)({}, dc, uc);
    return agent(config);
  };
};

function errorResponse(response, config) {
  return _promise2.default.reject(makeResponse(response, config));
}

function makeResponse(response, config) {
  var _parseData = parseData(response.data, config),
      code = _parseData.code,
      data = _parseData.data,
      message = _parseData.message;

  var res = {
    response: response
  };

  if (code) {
    res.code = Number(code);
  }

  if (data !== undefined) {
    res.data = data;
  }

  if (message) {
    res.message = message;
  }

  return res;
}

function parseData(data, config) {
  data = data || '';

  if (Object(data) !== data && config.responseType === STR_JSON) {
    try {
      return JSON.parse(data);
    } catch (e) {
      return data;
    }
  }

  return data;
}

var CancelToken = _axios2.default.CancelToken,
    isCancel = _axios2.default.isCancel,
    Cancel = _axios2.default.Cancel;
exports.default = agent;
exports.CancelToken = CancelToken;
exports.isCancel = isCancel;
exports.Cancel = Cancel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/axios/lib/index.js
// module id = 482
// module chunks = 0